import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonComponent } from '../skeleton/skeleton.component';

@Component({
  selector: 'app-appointment-skeleton',
  standalone: true,
  imports: [CommonModule, SkeletonComponent],
  templateUrl: './appointment-skeleton.component.html'
})
export class AppointmentSkeletonComponent {
  @Input() count: number = 5;
  @Input() variant: 'home' | 'selector' = 'home';

  get placeholders(): number[] {
    return Array.from({ length: this.count }, (_, i) => i);
  }
}
